import { useAppSelector } from 'store/hooks'

import {
	AllWidgetsContainer,
	CattlesContainer,
	DockContainer,
	FeedTableContainer,
	HealthTableContainer,
	MilkingRoutineTableContainer,
	MilkYieldTableContainer,
} from './components/dock-container'

import { DOCK_CATEGORIES_TYPES } from './types/dockTypes'

export const WidgetDock = () => {
	const { isWidgetDockVisible, selectedCategory } = useAppSelector(
		s => s.dashboardSlice,
	)

	if (!isWidgetDockVisible) return null
	const SELECTED_CATEGORY_CONTENT = {
		[DOCK_CATEGORIES_TYPES.ALL]: <AllWidgetsContainer />,
		[DOCK_CATEGORIES_TYPES.CATTLES]: <CattlesContainer />,
		[DOCK_CATEGORIES_TYPES.FOOD_TABLE]: <FeedTableContainer />,
		[DOCK_CATEGORIES_TYPES.HEALTH]: <HealthTableContainer />,
		[DOCK_CATEGORIES_TYPES.MILKING_PROCESS]: <MilkingRoutineTableContainer />,
		[DOCK_CATEGORIES_TYPES.MILK_YIELD]: <MilkYieldTableContainer />,
	}

	return (
		<DockContainer>{SELECTED_CATEGORY_CONTENT[selectedCategory]}</DockContainer>
	)
}

export default WidgetDock
